import React, { useContext, createContext } from "react";
import { Dashboard } from "./Dashboard.component";

// Try to import the real context; if it fails, use a no-op fallback.
let TasksContextImported: React.Context<any>;
try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  TasksContextImported = require("../../context/tasks/store").TasksContext;
} catch {
  TasksContextImported = createContext<any>({ isModalOpen: false });
}

export const DashboardContainer: React.FC = () => {
  const { isModalOpen } = useContext(TasksContextImported);
  return <Dashboard isModalOpen={!!isModalOpen} />;
};